<template>
    <div>
        <div class="container -todo">
            <ol class="breadcrumb">
                <li><a v-link="{name: 'home'}">Accueil</a></li>
                <li>Todo</li>
            </ol>

            <div class="heading">
                <h1>Todo</h1>
            </div>

            <div>
                <div class="filters-unlinked">
                    <div class="filters">
                        <div class="filter">
                            <h3>Statut</h3>
                            <div class="btn-group">
                                <button
                                    type="button"
                                    value=""
                                    :class="{active: state === ''}"
                                    @click.prevent="state = ''"
                                    class="btn btn-primary dropdown-toggle"
                                >
                                    Tout
                                </button>
                                <button
                                    type="button"
                                    v-for="(key, value) in states"
                                    :value="key"
                                    :class="{active: key === state}"
                                    @click.prevent="state = key"
                                    class="btn btn-primary dropdown-toggle"
                                >
                                    {{ value }}
                                </button>
                            </div>
                        </div>

                        <div class="filter">
                            <h3>Operation</h3>
                            <v-select
                                :value.sync="operation"
                                placeholder="Choisir"
                                :options="operationsSelect"
                                :close-on-select="true"
                            ></v-select>
                        </div>

                        <div class="filter">
                            <h3>À partir de</h3>
                            <editable-date :value.sync="dateStart"
                                           :enable-reset="true"
                                           placeholder="Définir..."></editable-date>
                        </div>
                        <div class="filter">
                            <h3>Jusqu'à</h3>
                            <editable-date :value.sync="dateStop"
                                           :enable-reset="true"
                                           placeholder="Définir..."></editable-date>
                        </div>
                    </div>

                    <div class="unlinked">
                        <a
                            v-link="{ name: 'unlinked-contracts' }"
                            class="btn btn-primary"
                            v-if="unlinkedContracts"
                        >
                            ({{ unlinkedContracts }})
                            Contrat<span v-if="unlinkedContracts > 1">s</span>
                            dissocié<span v-if="unlinkedContracts > 1">s</span>
                        </a>
                    </div>
                </div>

                <table v-if="todoList.length" class="table table-hover">
                    <tr>
                        <th>Operation</th>
                        <th>Numéro de contrat</th>
                        <th>Nom</th>
                        <th>Date</th>
                        <th>Statut</th>
                        <th></th>
                    </tr>

                    <tr v-for="todo of todoList" :class="{muted: todo.muted}">
                        <td>
                            {{ getOperationType(todo) }}
                            <span v-if="isVlp(todo.attached_operation)">
                                <span
                                    v-if="isVlpModification(todo.attached_operation)"
                                >
                                    (Modification)
                                </span>
                                <span v-else>(Mise en place)</span>
                            </span>
                        </td>
                        <td>{{ todo.attached_operation.contract_number }}</td>
                        <td class="name-col">{{ todo.attached_client.name }}</td>
                        <td>{{ formatDate(todo.date_start) }}</td>
                        <td>{{ states[todo.state] }}</td>
                        <td>
                            <a
                                v-link="{
                                        name: 'contracts-edit',
                                        params: {
                                            id: todo.attached_client.id,
                                            contractId: todo.attached_operation.contract
                                        },
                                        query: {
                                            tab: 'operations',
                                            id: todo.attached_operation.id
                                        }
                                    }"
                                class="btn btn-primary btn-sm"
                            >
                                Consulter
                            </a>

                        </td>
                    </tr>
                </table>

                <div v-if="!todoList.length && !loading" class="empty-list jumbotron" v-else>
                    <h2>Aucun to do</h2>
                </div>
            </div>

            <loader v-if="loading" class="bigger-loader"></loader>

            <div class="load-more">
                <a href="#"
                   v-if="hasNext && !loading"
                   v-on:click.prevent="updateFullList(true)"
                   class="btn btn-default">
                    Charger plus
                </a>
            </div>
        </div>
    </div>
</template>

<style scoped type="text/less" lang="less">
@import "../style/variables";

.cta-row {
    text-align: right;
    margin-top: 30px;
}

.empty-list {
    margin-top: 3rem;
}

.load-more {
    text-align: center;
    margin: 20px 0;
}

.todo-preview {
    &.-muted {
        color: @gray-light;
    }

    a {
        color: @brand-primary;
    }
}

/**
 * Heading styles
 */
.heading {
    align-items: center;
    display: flex;
    justify-content: space-between;
}


/**
 * Filter/unlinked section styles. Filters are shown at left side and unlinked
 * button at right side.
 */
.filters-unlinked {
    align-items: center;
    display: flex;
    justify-content: space-between;

    .filters {
        display: flex;
        margin-top: 3rem;

        .filter {
            padding-right: 6rem;

            p {
                margin: 0 0 6px;
            }

            select {
                padding: 0.7rem 1.2rem;
            }
        }
    }
}



/**
 * Table styles
 */
.table {
    margin: 5rem auto;

    tr {

        &.muted {
            color: @gray-light
        }

        .btn {
            text-transform: none;
        }

        .name-col {
            min-width: 190px;
            text-transform: uppercase;
        }
    }
}
</style>

<script type="text/ecmascript-6">
import Loader from '../components/Loader';
import EditableDate from '../components/editable/EditableDate';
import VSelect from 'vue-strap/src/Select';
import moment from 'moment';
import {manager as msgManager} from '../messages';
import {makeUpdateList} from '../utils';
import {listAll, mute, seeLatest} from '../api/todo';
import {pendingUnlinkedContracts} from '../api/unlinked_contracts';

export default {
    components: {
        Loader,
        EditableDate,
        VSelect
    },
    data() {
        return {
            states: {
                todo: 'A traiter',
                imported: 'Traité',
                done: 'Validé'
            },
            state: '',
            operationsSelect: [
                { value: '', label: 'Tout' },
                { value: 'SUBSCRIPTION', label: 'Souscription' },
                { value: 'DEPOSIT', label: 'Versement libre' },
                { value: 'WITHDRAWAL', label: 'Rachat partiel' },
                {
                    value: 'PERIODICPAYMENTSETUP',
                    label: 'Versement libre programmé (Mise en place)'
                },
                {
                    value: 'PERIODICPAYMENTMODIFICATION',
                    label: 'Versement libre programmé (Modification)'
                },
                { value: 'PERIODICPAYMENTSUSPENSION', label: 'Versement libre programmé (Arrêt)' },
                { value: 'RATTACHEMENT', label: 'Rattachement contrat' },
                { value: 'SAXOMIGRATION', label: 'Saxo migration' }
            ],
            operation: '',
            dateStart: undefined,
            dateStop: undefined,
            muting: [],
            todoList: [],
            hasNext: false,
            page: 1,
            loading: true,
            unlinkedContracts: 0
        };
    },
    async ready() {
        /**
         * If the page is reached from a redirect after deleting and operation,
         * a success message is displayed.
         */
        if (localStorage.getItem('opDel')) {
            msgManager.push('Succès', 'Operation supprimée', 'success');
            localStorage.removeItem('opDel');
        }
        seeLatest();
        this.updateFullList();
        const pending = await pendingUnlinkedContracts();
        this.unlinkedContracts = pending.number;
    },
    computed: {
        searchQuery() {
            return {
                state: this.state,
                operation: this.operation,
                start: this.dateStart,
                stop: this.dateStop
            };
        }
    },

    watch: {
        searchQuery() {
            this.updateFullList();
        }
    },

    methods: {
        updateFullList: makeUpdateList({
            loading: 'loading',
            page: 'page',
            hasNext: 'hasNext',
            list: 'todoList',
            fetch: async function (page) {
                return await listAll(
                    page, this.state, this.operation, this.dateStart, this.dateStop
                );
            }
        }),

        /**
         * Check if a TO DO is currently being muted
         */
        isMuting(id) {
            return this.muting.some((x) => x === id);
        },

        /**
         * Toggle the muting of a to do
         */
        mute: async function (todo) {
            if (this.isMuting(todo.id)) {
                return;
            }

            this.muting.push(todo.id);

            await mute(todo.id, !todo.muted);
            todo.muted = !todo.muted;

            this.muting = this.muting.filter((x) => x !== todo.id);
        },

        /**
         * Determines if operation is a periodic payment.
         */
        isVlp(operation) {
            if (operation.extra.request) {
                return operation.extra.request.type.toUpperCase() === 'PERIODICPAYMENT';
            }
            return false;
        },

        /**
         * For periodic payments, determines if it's a modification or not
         */
        isVlpModification(operation) {
            return (
                this.isVlp(operation) &&
                operation.extra.request.data.versement.is_modification
            );
        },

        formatDate(date) {
            return moment(date, 'YYYY-MM-DD').format('L');
        },

        /**
         * Returns the specific operation type, including Saxo Migration.
         */
        getOperationType(todo) {
            if (
                todo.attached_operation.type === 'Souscription' &&
                todo.attached_operation.from_saxo
            ) {
                return 'Saxo Migration';
            }
            return todo.attached_operation.type;
        }
    }
};
</script>



// WEBPACK FOOTER //
// Todo.vue?8e64ee64